import {
  type QueryClient,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import {
  type PaginatedCustomerFoodFeedbackList,
  StatusCode,
} from '@hungryroot/rest';
import {
  getApiV2CustomersSelfFoodFeedback,
  type Params,
} from '@hungryroot/rest/api/v2/customers/self/food_feedback/get';

type useSelfFoodFeedbacksProps = {
  params: Params;
  options?: Omit<
    UseQueryOptions<PaginatedCustomerFoodFeedbackList>,
    'queryFn' | 'queryKey'
  >;
};

function getQueryKey(params?: useSelfFoodFeedbacksProps['params']) {
  return ['Customer', 'Food Feedback', params];
}

export function invalidateQuery({
  params,
  queryClient,
}: {
  params: Params;
  queryClient: QueryClient;
}) {
  queryClient.invalidateQueries({
    queryKey: getQueryKey(params),
  });
}

export function useSelfFoodFeedbacks(props?: useSelfFoodFeedbacksProps) {
  const { params, options } = props || {};

  return useQuery({
    queryKey: getQueryKey(params),
    queryFn: async () => {
      const res = await getApiV2CustomersSelfFoodFeedback(params);

      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }

      return res.data;
    },
    ...options,
  });
}
